import { render } from "./VisaView.vue?vue&type=template&id=6205d546&scoped=true"
import script from "./VisaView.vue?vue&type=script&lang=js"
export * from "./VisaView.vue?vue&type=script&lang=js"

import "./VisaView.vue?vue&type=style&index=0&id=6205d546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6205d546"]])

export default __exports__